import { render } from "./CapabilitiesStatement.vue?vue&type=template&id=c9bf50f4"
import script from "./CapabilitiesStatement.vue?vue&type=script&lang=js"
export * from "./CapabilitiesStatement.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__